import ko from 'knockout';
import BaseViewModel from '@bingads-webui-static-legacy/bulk-edit/viewmodel/bulkEditJob';
import timeZoneMapper from '@bingads-webui-component-legacy/timezonemapper/index';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/feature/bulk-campaign-exclusions');

export default class ViewModel {
  constructor() {
    BaseViewModel.call(this);

    this.adScheduleUseSearcherTimeZone = ko.observable(false);
    this.adScheduleUseSearcherTimeZoneEdit = ko.computed({
      read() {
        return this.adScheduleUseSearcherTimeZone().toString();
      },
      write(value) {
        this.adScheduleUseSearcherTimeZone(value === 'true');
      },
    }, this);

    this.timeZoneText = timeZoneMapper.getAccountTimeZoneText();
    this.i18n = i18n;
  }
}
